import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSymmetry = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_84",
		"data-name": "Group 84",
		transform: "translate(-141.595 -130.49)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_79",
				"data-name": "Group 79",
				transform: "translate(142.87 134.147)",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Path_2152",
					"data-name": "Path 2152",
					transform: "translate(0 0)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_203",
						"data-name": "Path 203",
						d: "M149.623,156.935c-2.374,0-2.886-3.045-3.167-4.716-.051-.306-.1-.582-.147-.806-.067-.3-.215-.761-.386-1.3a15.365,15.365,0,0,1-.925-4.075,6.622,6.622,0,0,1,1.8-4.813,3.519,3.519,0,0,1,2.715-.97c2.141.156,3.262,2.532,3.262,4.8a8.77,8.77,0,0,1-.465,2.7,5.453,5.453,0,0,0-.311,1.577,13.754,13.754,0,0,0,.2,1.821c.25,1.683.534,3.592-.378,4.784a2.594,2.594,0,0,1-1.843.974h0A3,3,0,0,1,149.623,156.935Zm-.383-15.187a2.038,2.038,0,0,0-1.423.578,5.2,5.2,0,0,0-1.32,3.715,14.828,14.828,0,0,0,.853,3.617c.183.57.34,1.063.422,1.427.055.245.106.549.163.885.384,2.282.813,3.577,1.865,3.455a1.1,1.1,0,0,0,.827-.4c.527-.688.282-2.332.086-3.652a14.692,14.692,0,0,1-.214-2.042,6.771,6.771,0,0,1,.374-2.005,7.416,7.416,0,0,0,.4-2.271c0-1.558-.7-3.219-1.871-3.3C149.348,141.75,149.293,141.748,149.239,141.748Z",
						transform: "translate(-144.997 -140.248)",
						fill: "current"
					})
				}), /* @__PURE__ */ _jsx("g", {
					id: "Path_2153",
					"data-name": "Path 2153",
					transform: "translate(13.675 0)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_204",
						"data-name": "Path 204",
						d: "M184.635,156.935a3,3,0,0,1-.35-.021h0a2.594,2.594,0,0,1-1.843-.974c-.913-1.192-.628-3.1-.378-4.784a13.754,13.754,0,0,0,.2-1.821,5.453,5.453,0,0,0-.311-1.577,8.771,8.771,0,0,1-.465-2.7c0-2.267,1.12-4.644,3.262-4.8a3.525,3.525,0,0,1,2.715.97,6.622,6.622,0,0,1,1.8,4.813,15.366,15.366,0,0,1-.925,4.075c-.171.536-.319,1-.386,1.3-.051.224-.1.5-.148.807C187.521,153.89,187.008,156.935,184.635,156.935Zm-.176-1.51c1.062.124,1.481-1.174,1.865-3.455.057-.336.108-.639.163-.885.081-.364.239-.856.422-1.426a14.827,14.827,0,0,0,.853-3.617,5.2,5.2,0,0,0-1.32-3.715,2.04,2.04,0,0,0-1.586-.572c-1.171.085-1.871,1.747-1.871,3.3a7.415,7.415,0,0,0,.4,2.271,6.771,6.771,0,0,1,.374,2.005,14.7,14.7,0,0,1-.214,2.042c-.2,1.32-.441,2.964.086,3.652a1.1,1.1,0,0,0,.827.4Z",
						transform: "translate(-181.485 -140.249)",
						fill: "current"
					})
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_83",
				"data-name": "Group 83",
				transform: "translate(152.846 132.888)",
				children: [
					/* @__PURE__ */ _jsx("g", {
						id: "Group_80",
						"data-name": "Group 80",
						transform: "translate(0 0)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_205",
							"data-name": "Path 205",
							d: "M172.365,140.637a.75.75,0,0,1-.75-.75v-2.249a.75.75,0,1,1,1.5,0v2.249A.75.75,0,0,1,172.365,140.637Z",
							transform: "translate(-171.615 -136.889)",
							fill: "current"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_81",
						"data-name": "Group 81",
						transform: "translate(0 6.651)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_206",
							"data-name": "Path 206",
							d: "M172.365,160.538a.75.75,0,0,1-.75-.75v-4.4a.75.75,0,1,1,1.5,0v4.4A.75.75,0,0,1,172.365,160.538Z",
							transform: "translate(-171.615 -154.636)",
							fill: "current"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_82",
						"data-name": "Group 82",
						transform: "translate(0 15.456)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_207",
							"data-name": "Path 207",
							d: "M172.365,181.879a.75.75,0,0,1-.75-.75v-2.249a.75.75,0,0,1,1.5,0v2.249A.749.749,0,0,1,172.365,181.879Z",
							transform: "translate(-171.615 -178.131)",
							fill: "current"
						})
					})
				]
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_21",
				"data-name": "Rectangle 21",
				width: 24,
				height: 24,
				transform: "translate(141.595 130.49)",
				fill: "none"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgSymmetry);
export { ForwardRef as ReactComponent };
